import { useState, useCallback } from 'react';

export type RippleType = {
	id: number;
	x: number;
	y: number;
};

/**
 * Кастомный хук для создания эффекта волны (ripple effect) при клике на элемент
 * @returns объект с массивом ripples и функцией createRipple
 * @example
 * const { ripples, createRipple } = useRippleEffect();
 * 
 * <button onClick={createRipple}>
 *   Click me
 *   {ripples.map(ripple => (
 *     <span key={ripple.id} className="ripple" style={{left: ripple.x, top: ripple.y}} />
 *   ))}
 * </button>
 */
export const useRippleEffect = () => {
	const [ripples, setRipples] = useState<RippleType[]>([]);

	const createRipple = useCallback((e: React.MouseEvent<HTMLElement>) => {
		const rect = e.currentTarget.getBoundingClientRect();
		const x = e.clientX - rect.left;
		const y = e.clientY - rect.top;

		const newRipple: RippleType = {
			id: Date.now(),
			x,
			y,
		};

		setRipples((prev) => [...prev, newRipple]);

		// Удаляем волну через 600ms
		setTimeout(() => {
			setRipples((prev) => prev.filter((ripple) => ripple.id !== newRipple.id));
		}, 600);
	}, []);

	return { ripples, createRipple };
};

